module.exports = __webpack_public_path__ + "static/img/图片10.9173264f.png";